export default __webpack_public_path__ + "static/media/m-btn-check-defualt.4525d45f.svg";